import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AuthLogo from "./AuthLogo";

const RegisterView = ({
  siteName,
  registerEmail,
  registerPassword,
  confirmPassword,
  termsAccepted,
  submitting,
  inlineError,
  onEmailChange,
  onPasswordChange,
  onConfirmPasswordChange,
  onTermsChange,
  onSubmit,
  onLoginClick
}) => {
  const { t } = useTranslation("common");

  return (
    <>
      <AuthLogo siteName={siteName} />

      <h1 className="auth-title">{t("Create your account")}</h1>
      <p className="auth-subtitle">
        {t("Start connecting Odoo in minutes — free to get started")}
      </p>

      <form onSubmit={onSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="register-first-name">
              {t("First name")}
            </label>
            <input
              type="text"
              id="register-first-name"
              className="form-control"
              placeholder={t("First name")}
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="register-last-name">
              {t("Last name")}
            </label>
            <input
              type="text"
              id="register-last-name"
              className="form-control"
              placeholder={t("Last name")}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="register-email">
            {t("Work email")}
          </label>
          <input
            type="email"
            id="register-email"
            className="form-control"
            placeholder={t("you@company.com")}
            value={registerEmail}
            onChange={(event) => onEmailChange(event.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="register-company">
            {t("Company / Organisation")}
          </label>
          <input
            type="text"
            id="register-company"
            className="form-control"
            placeholder={t("PrestoCharts Inc.")}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="register-password">
              {t("Password")}
            </label>
            <input
              type="password"
              id="register-password"
              className="form-control"
              placeholder={t("Min. 8 characters")}
              value={registerPassword}
              onChange={(event) => onPasswordChange(event.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="register-confirm-password">
              {t("Confirm password")}
            </label>
            <input
              type="password"
              id="register-confirm-password"
              className="form-control"
              placeholder={t("Repeat password")}
              value={confirmPassword}
              onChange={(event) => onConfirmPasswordChange(event.target.value)}
              required
              autoComplete="new-password"
            />
          </div>
        </div>

        <div className="auth-terms">
          <input
            type="checkbox"
            id="register-terms"
            checked={termsAccepted}
            onChange={(event) => onTermsChange(event.target.checked)}
            required
          />
          <label htmlFor="register-terms">
            {t("I agree to the")}{" "}
            <a href="#terms">{t("Terms of Service")}</a> {t("and")}{" "}
            <a href="#privacy">{t("Privacy Policy")}</a>
          </label>
        </div>

        <div className={`auth-inline-error ${inlineError ? "visible" : ""}`}>{inlineError}</div>

        <button type="submit" className="btn btn-gradient btn-lg btn-full" disabled={submitting}>
          {submitting ? t("Creating account…") : t("Create Account")}
        </button>
      </form>

      <div className="auth-footer" style={{ marginTop: "16px" }}>
        <span>{t("Already have an account?")} </span>
        <button type="button" onClick={onLoginClick}>
          {t("Sign in →")}
        </button>
      </div>
    </>
  );
};

RegisterView.propTypes = {
  siteName: PropTypes.string.isRequired,
  registerEmail: PropTypes.string.isRequired,
  registerPassword: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  termsAccepted: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  inlineError: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onConfirmPasswordChange: PropTypes.func.isRequired,
  onTermsChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired
};

export default RegisterView;
